export type NameType = 'collapsed';

export const name: NameType = 'collapsed';
